var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImageBlockIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 10 10",
    fill: "white",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.79749 0.599976H2.20285C0.986493 0.599976 0 1.58647 0 2.80283V7.14708C0 8.36379 0.986493 9.34993 2.20285 9.34993H7.79715C9.01386 9.34993 10 8.36344 10 7.14708V2.80283C10 1.58612 9.01351 0.599976 7.79715 0.599976H7.79749ZM2.20285 1.71113H7.79715C8.39925 1.71113 8.88885 2.20107 8.88885 2.80283V5.89078L7.58012 4.58206C7.3631 4.36504 7.01135 4.36504 6.79433 4.58206L5.93701 5.43938L4.29841 3.80078C4.08139 3.58376 3.72964 3.58376 3.51262 3.80078L1.11011 6.2033V2.80283C1.11011 2.20073 1.60006 1.71113 2.20181 1.71113H2.20285ZM7.79715 8.23913H2.20285C1.78235 8.23913 1.41706 8.00023 1.23477 7.65126L3.90639 4.97964L5.54498 6.61824C5.76201 6.83526 6.11375 6.83526 6.33078 6.61824L7.1881 5.76092L8.85343 7.42625C8.72982 7.89363 8.30341 8.23948 7.79784 8.23948L7.79715 8.23913Z",
    fill: "current"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.25028 2.16254C5.73255 2.16254 5.31274 2.58234 5.31274 3.10007C5.31274 3.6178 5.73255 4.0376 6.25028 4.0376C6.768 4.0376 7.18781 3.6178 7.18781 3.10007C7.18781 2.58234 6.768 2.16254 6.25028 2.16254Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImageBlockIcon);
export default __webpack_public_path__ + "static/media/ImageBlockIcon.857bba2ac21e0362767a73317158d0b3.svg";
export { ForwardRef as ReactComponent };